import { Monitor, Moon, Palette, Sun } from 'lucide-react';
import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu';
import { useThemeStore, type ThemePreference } from '@/stores/themeStore';

const LABELS: Record<ThemePreference, string> = { light: 'Light', dark: 'Dark', system: 'System' };

/** Appearance ▸ Light / Dark / System. Renders inside a DropdownMenuContent. */
export function ThemeMenuSub() {
  const preference = useThemeStore((s) => s.preference);
  const setPreference = useThemeStore((s) => s.setPreference);

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <Palette />
        <span>Appearance</span>
        <span className="ml-auto text-xs text-ink-3">{LABELS[preference]}</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="w-44" sideOffset={6} alignOffset={-4}>
        <DropdownMenuRadioGroup value={preference} onValueChange={(v) => setPreference(v as ThemePreference)}>
          <DropdownMenuRadioItem value="light">
            <Sun />
            Light
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="dark">
            <Moon />
            Dark
          </DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="system">
            <Monitor />
            System
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
